import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { shellTabs, activeShellTab } from '@/constants/shellNavConfig';
import { cn } from '@/lib/utils';
import { ShellAccountMenu } from './ShellAccountMenu';
import { ShellBrandLogo } from './ShellBrandLogo';
import { ShellPlaceholderActions } from './ShellPlaceholderActions';

/** Full-width product header: lockup, horizontal destinations, account. */
export function ShellTabBar() {
  const { pathname } = useLocation();
  const activeTab = activeShellTab(pathname);

  return (
    <header className="shell-tab-bar hidden lg:flex flex-shrink-0 items-center gap-6 px-4">
      <ShellBrandLogo size="nav" className="flex-shrink-0" />
      <nav className="flex min-w-0 items-center gap-1" aria-label="Main">
        {shellTabs.map((tab) => {
          const active = tab.id === activeTab;
          const Icon = tab.icon;
          return (
            <Link
              key={tab.id}
              to={tab.to}
              title={tab.label}
              aria-current={active ? 'page' : undefined}
              className={cn(
                'shell-tab inline-flex h-11 items-center gap-2 rounded-lg px-3.5 text-sm font-medium',
                active && 'shell-tab--active',
              )}
            >
              <Icon className="h-4 w-4 shrink-0" strokeWidth={1.75} aria-hidden />
              <span className="truncate">{tab.shortLabel}</span>
            </Link>
          );
        })}
      </nav>
      <div className="ml-auto flex flex-shrink-0 items-center gap-3">
        <ShellAccountMenu compact />
        <ShellPlaceholderActions />
      </div>
    </header>
  );
}
